export default{
    cartList:[]
}


// WEBPACK FOOTER //
// ./src/store/state.js